// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B-5v","colBig":"styles_colBig__1kBNl","colSmall":"styles_colSmall__Qjr6c","shopifyNameWrapper":"styles_shopifyNameWrapper__3gQqD"};